import { Injectable } from '@angular/core';

import { map, catchError } from 'rxjs/operators';
import { APIBaseService } from './api_base.service';
import { domain } from 'src/environments/environment';
@Injectable({
    providedIn: 'root',
})
export class UploadAPIService extends APIBaseService {
    namespace = 'upload';

    // UPLOAD FILE
    async uploadFile(data:any) {
        const url = `${domain}/${this.namespace}/`;
        return this.http.post(url, data, this.getHeader()).pipe(
            map((results) => results),
            catchError((error) => {
                console.log(error);
                this.errorHandle(error);
                return Promise.resolve({ ok: false });
            })
        );
    }

}
